/* Sprint 22 — appointment display helpers.
   Begutachtung entries share a single neutral color across all calendar views,
   independent of any provisionally chosen service color. */

export const BEGUTACHTUNG_COLOR = "#94A3B8"; // slate-400 — neutral, pale.

/** Returns the color the calendar chip should render with.
 *  Begutachtung → always the neutral grey.
 *  Arbeitstermin → the appointment's stored service color. */
export function chipColor(a) {
  if (!a) return BEGUTACHTUNG_COLOR;
  return (a.terminart === "begutachtung") ? BEGUTACHTUNG_COLOR : (a.color || "#3377FF");
}

/** All distinct service colors attached to an appointment.
 * Legacy/single-service appointments fall back to chipColor(). */
export function serviceColors(a) {
  if (!a || a.terminart === "begutachtung") return [BEGUTACHTUNG_COLOR];
  const colors = (a.services || [])
    .map((service) => service?.color)
    .filter(Boolean);
  return [...new Set(colors.length ? colors : [chipColor(a)])];
}
